import { faArrowDownLong, faArrowUpLong } from '@fortawesome/pro-light-svg-icons'
import TwinIcon from '../../../../../../../../baseComponents/TwinIcon'

export interface ConfigPdfTemplateChangePosIconsProps {
    handleChangePositionUp: () => void
    handleChangePositionDown: () => void
}

const ConfigPdfTemplateChangePosIcons: React.FC<ConfigPdfTemplateChangePosIconsProps> = ({ handleChangePositionDown, handleChangePositionUp }) => {
    return (
        <div className='ml-5 min-w-fit'>
            <TwinIcon icon={faArrowDownLong} className='ml-auto cursor-pointer w-7 mr-5 hover:text-green-21' onClick={handleChangePositionDown} />
            <TwinIcon icon={faArrowUpLong} className='ml-auto cursor-pointer w-7 hover:text-green-21' onClick={handleChangePositionUp} />
        </div>
    )
}


export default ConfigPdfTemplateChangePosIcons